<template>
<div class='centralized-issues-cycles-table-cell'>
  <numeric-cycles class='centralized-issues-cycles-table-cell__cycles' :data='Number(item.cycles)' />
</div>
</template>

<script>
import NumericCycles from '@/components/issue/NumericCycles.vue';

export default {
  name: 'IssueCycleTableCell',
  components: { NumericCycles },
  props: {
    item: {
      type: Object,
      required: true,
    },
    column: {
      type: Object,
      required: true,
    },
  },
};
</script>

<style lang='scss' scoped>
.centralized-issues-cycles-table-cell{
  display: flex;
  justify-content: center;
  align-content: center;
  width: 69px;
  &__cycles{
    margin-right: 14px;
    margin-top: 10px;
  }
}
</style>
